<template>
  <FormHeading :h="4">
    {{ $tt('image_upload_instructions') }}
  </FormHeading>
  <AppRow class="mb-7" sequence-two unwrapped>
    <AppCol v-for="{ header, body, src } in neededInstructions">
      <ImageUploadInstruction :header :body :src />
    </AppCol>
  </AppRow>
  <AppAlert type="success" icon="mdi:cellphone" class="mb-3">
    {{ $tt('may_use_phone_camera') }}
  </AppAlert>
  <AppAlert type="info" icon="mdi:shield-account">
    {{ $tt('privacy_autodelete', { year: getCurrentYear() }) }}
  </AppAlert>
</template>

<script setup lang="ts">
import { getCurrentYear } from '~/helpers/date';
import type { ApplicantPhotoType, Product } from '~/types';

interface Instruction {
  imageType: ApplicantPhotoType;
  header: string;
  body: string;
  src: string;
}

const props = defineProps<{
  types: Product['photo_types'];
}>();

const { passportExample } = useBranch();
const { tt } = useLocalization();

const instructions: Instruction[] = [
  {
    imageType: 'face',
    header: tt('applicant_photos.face'),
    body: tt('applicant_photos.face_desc'),
    src: '/images/photo-examples/face.jpg'
  }, {
    imageType: 'passport',
    header: tt('applicant_photos.passport'),
    body: tt('applicant_photos.passport_desc'),
    src: '/images/photo-examples/passports/' + passportExample
  }, {
    imageType: 'card',
    header: tt('applicant_photos.card'),
    body: tt('applicant_photos.card_desc'),
    src: '/images/photo-examples/business-card.webp'
  }, {
    imageType: 'invitation',
    header: tt('applicant_photos.invitation'),
    body: tt('applicant_photos.invitation_desc'),
    src: '/images/photo-examples/invitation.webp'
  }, {
    imageType: 'return_ticket',
    header: tt('applicant_photos.return_ticket'),
    body: tt('applicant_photos.return_ticket_desc'),
    src: '/images/photo-examples/flight.webp'
  }, {
    imageType: 'booking',
    header: tt('applicant_photos.booking'),
    body: tt('applicant_photos.booking_desc'),
    src: '/images/photo-examples/booking.webp'
  }, {
    imageType: 'bank',
    header: tt('applicant_photos.bank'),
    body: tt('applicant_photos.bank_desc'),
    src: '/images/photo-examples/bank-statement.webp'
  }, {
    imageType: 'address_proof',
    header: tt('applicant_photos.address_proof'),
    body: tt('applicant_photos.address_proof_desc'),
    src: '/images/photo-examples/address-proof.jpg'
  }, {
    imageType: 'occupation',
    header: tt('applicant_photos.occupation'),
    body: tt('applicant_photos.occupation_desc'),
    src: '/images/photo-examples/occupation.webp'
  }, {
    imageType: 'travel_ticket',
    header: tt('applicant_photos.travel_ticket'),
    body: tt('applicant_photos.travel_ticket_desc'),
    src: '/images/photo-examples/travel-ticket.webp'
  }
];
const neededInstructions = computed(() => {
  return instructions.filter(i => props.types!.includes(i.imageType));
});
</script>